import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/common/link';
import { getProductPath } from 'lib/router';
import { typedef } from 'lib/product';
import * as analytics from 'lib/analytics';

const ProductLink = ({
  product,
  children,
  initialAddonOptions = [],
  ...others
}) => {
  const url = initialAddonOptions?.length
    ? `${getProductPath(
        product.slug || product.id,
      )}?${initialAddonOptions
        ?.map((addon) => `addon_${addon.id}=${addon.value}`)
        .join('&')}`
    : getProductPath(product.slug || product.id);

  return (
    <Link
      {...others}
      to={url}
      onClick={(e) => {
        analytics.viewProduct({ product });
        others?.onClick?.(e);
      }}
    >
      {children}
    </Link>
  );
};

ProductLink.propTypes = {
  product: typedef.Product,
  children: PropTypes.node,
  initialAddonOptions: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  ),
};

ProductLink.defaultProps = {
  initialAddonOptions: [],
};

export default ProductLink;
